import styled from "styled-components";

const Container = styled.div`
  align-items: ${(props) => (props.centered ? "center" : "flex-start")};
  justify-content: space-between;
  width: 80%;
`;

export default Container;
